<template>
    <div class="ngdialog-content">
        <dialog-header :showClose="!showAccept">
            <h3 v-html="title"></h3>
            <span v-if="version !== '' && updatedDate !== '' && this.lastUpdated.length > 0" class="version">Version: {{ version }}, {{ updatedDate }}</span>
        </dialog-header>

        <div class="ngdialog__body align-justify" v-html="content"></div>

        <div class="ngdialog__button-group" v-if="showAccept">
            <div class="ngdialog__button-group__item">
                <button type="button" class="ngdialog__button ngdialog__button--primary" @click="acceptTermsClickHandler">
                    <span class="ngdialog__button__text">{{ $t('buttons.accept') }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import * as api from '@/api';
import { mapState } from 'vuex';
import * as moment from 'moment';
import DialogHeader from '@/components/DialogHeader';

export default {
    components: {
        DialogHeader,
    },
    props: {
        showAccept: {
            type: Boolean,
            default: false,
        },
        html: {
            type: String,
            default: '',
        },
        lastUpdated: {
            type: String,
            default: '',
        },
        version: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            title: '',
            content: '',
        };
    },
    computed: {
        ...mapState(['userData']),
        updatedDate() {
            return moment(this.lastUpdated).format('YYYY-MM-DD');
        },
    },
    mounted() {
        this.formatHtml();
    },
    methods: {
        formatHtml() {
            // extract first h3 as title
            if (this.html.indexOf('<h3>') === 0) {
                const splitString = this.html.split('</h3>');
                this.title = splitString[0] + '</h3>';
                splitString.shift();
                this.content = splitString.join('');
            }
        },
        acceptTermsClickHandler() {
            this.acceptTerms();
        },
        async acceptTerms() {
            try {
                const data = { ...this.userData };
                data.accepted_data_policy_version = this.userData.pending_data_policy.version;
                const response = await api.users.update({
                    user: {
                        accepted_data_policy_version: this.userData.pending_data_policy.version,
                    },
                });
                if (response) {
                    this.$emit('close');
                }
            } catch (error) {
                console.error(error);
            }
        },
    },
};
</script>
